import React from 'react';
import { AgreementVisit } from '../../../../models/AgreementMetadata';
import { AgreementVisitListItem } from './AgreementVisitListItem';
import styles from './agreement_visits.module.scss';

type Props = {
  visits: AgreementVisit[];
}

/**
 * Renders a list of visists to an agreement.
 */
export const AgreementVisitList: React.FC<Props> = ({ visits }) => (
  <ul className={styles.list}>
    {
      visits.map(visit => (
        <AgreementVisitListItem key={visit.id} visit={visit} />
      ))
    }
  </ul>
)